/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28.7 27.3L19.5 18c1.3-1.6 2-3.6 2-5.8 0-5.1-4.1-9.2-9.2-9.2S3 7.1 3 12.2s4.1 9.2 9.2 9.2c2.2 0 4.2-.8 5.8-2l9.3 9.3 1.4-1.4zM5 12.2C5 8.3 8.3 5 12.2 5s7.2 3.3 7.2 7.2-3.3 7.2-7.2 7.2S5 16.2 5 12.2z"/>'
  }
})
